import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'EmptyLayout',
  props: {
    showBlogBtn: { type: Boolean },
    showBgImage: { type: Boolean },
    withOverflow: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})